<template>
  <v-dialog v-model="show" persistent full-width light>
    <gh-model-view :model="model" :props="modelProps" ref="view">
      <template #title>
        <slot name="title" :title="title" :model="model">
          <span class="headline">{{ title }}</span>
          <v-spacer></v-spacer>
        </slot>
      </template>
      <template v-slot="{model,props}">
        <slot :model="model" :props="props"></slot>
      </template>
      <template :slot="'model-prop-'+item.value" slot-scope="{prop,model}" v-for="item in modelProps">
        <slot :name="'model-prop-'+item.value" :prop="item" :model="model">

        </slot>
      </template>
      <template #actions>
        <v-spacer></v-spacer>
        <slot name="actions">
          <v-btn ref="btnCancel" color="info" flat>取消</v-btn>
          <v-btn x-large ref="btnOk" color="success" @click="validate">确定</v-btn>
        </slot>
      </template>
    </gh-model-view>


  </v-dialog>
</template>

<style scoped>

</style>

<script>
  import GhDialog from "./ghDialog.ts";
  export default GhDialog;
</script>